import script from "./StaffLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./StaffLayout.vue?vue&type=script&setup=true&lang=js"

import "./StaffLayout.vue?vue&type=style&index=0&id=0ee66aca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ee66aca"]])

export default __exports__